import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vedioFile",
  "use": "icon-vedioFile-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-vedioFile\"><defs><style type=\"text/css\"></style></defs><path d=\"M981.333 968.533c0 29.867-25.6 55.467-59.733 55.467H102.4c-34.133 0-59.733-25.6-59.733-55.467V55.467C42.667 25.6 68.267 0 102.4 0H768v102.4l93.867 110.933h119.466v755.2z\" fill=\"#AC8CE0\" p-id=\"3915\" /><path d=\"M256 896h512V384H256z\" fill=\"#FEFEFE\" p-id=\"3916\" /><path d=\"M768 0v89.6c0 8.533 21.333 115.2 34.133 123.733l179.2 128v-128L768 0z\" fill=\"#8D73BF\" p-id=\"3917\" /><path d=\"M768 0v170.667c0 25.6 21.333 42.666 42.667 42.666h170.666L768 0z\" fill=\"#CAB7ED\" p-id=\"3918\" /><path d=\"M405.333 768V512l213.334 128z\" fill=\"#AC8CE0\" p-id=\"3919\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/vedioFile.svg
// module id = rOdt
// module chunks = 48